import { createContext, useContext } from "react";
import { useDynamicSegmentCounts } from "../../segment/hooks/use-dynamic-segment-counts";

import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { FC, JSX } from "react";

interface LexicalDynamicContextType {
  segmentCounts: UseSupabaseLoaderState<Record<string, { name: string; count: number }>>;
}

const LexicalContext = createContext<LexicalDynamicContextType | null>(null);

export const LexicalDynamicContentContextProvider: FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const segmentCounts = useDynamicSegmentCounts();

  // oxlint-disable-next-line react/jsx-no-constructed-context-values -- Context value is rebuilt each render; memoising it is a separate change
  return <LexicalContext.Provider value={{ segmentCounts }}>{children}</LexicalContext.Provider>;
};

export const useLexicalDynamicContentContext = (): LexicalDynamicContextType => {
  const context = useContext(LexicalContext);
  if (!context) {
    throw new Error("useLexicalContext must be used within a LexicalContextProvider");
  }
  return context;
};
